import Image from "@/components/Image";
import Link from "@/components/link/Link";
import { ContentAuthor, Maybe } from "@/graphql/gql/graphql";
import { getDistinctUpdatedBy, getTwitterAccount } from "@/utils/author";
import { relativeDate } from "@/utils/date";
import styles from "./authorCommon.module.scss";

type AuthorCommonProps = {
  author: ContentAuthor;
  date: string;
  updatedBy?: Maybe<ContentAuthor>;
};

const AuthorCommon = ({ author, date, updatedBy }: AuthorCommonProps) => {
  const { slug, socialMedia } = author;
  const twitterAccount = socialMedia && getTwitterAccount(socialMedia);
  const distinctUpdatedBy = getDistinctUpdatedBy(author, updatedBy);

  return (
    <div className={styles.container}>
      <Image
        alt={author.name}
        src={author?.thumbnailUrl ?? "/research/images/personPlaceholder.svg"}
        width={36}
        height={36}
        className={styles.image}
      />
      <div className={styles.publishInfo}>
        <div className={styles.authorAndTwitter}>
          {slug ? (
            <Link next href={`/author/${slug}`}>
              {author.name}
            </Link>
          ) : (
            <span>{author.name}</span>
          )}
          {twitterAccount && (
            <>
              <span className={styles.separator}>•</span>
              <a
                href={twitterAccount.url}
                target="_blank"
                rel="noreferrer"
                className={styles.contentLink}
              >
                {twitterAccount.accountName}
              </a>
            </>
          )}
        </div>
        <time dateTime={date} suppressHydrationWarning>
          {relativeDate(date)}
        </time>
        {distinctUpdatedBy && (
          <span data-testid="updated-by">
            Updated by{" "}
            {distinctUpdatedBy.slug ? (
              <Link next href={`/author/${distinctUpdatedBy.slug}`}>
                {distinctUpdatedBy.name}
              </Link>
            ) : (
              distinctUpdatedBy.name
            )}
          </span>
        )}
      </div>
    </div>
  );
};

export default AuthorCommon;
